// extracted by mini-css-extract-plugin
export var container = "_hs-0";
export var content = "_hs-3";
export var customerTitle = "_hs-4";
export var empty = "_hs-5";
export var gray = "_hs-6";
export var header = "_hs-7";
export var info = "_hs-8";
export var loading = "_hs-2";
export var loadingCard = "_hs-9";
export var oneLine = "_hs-a";
export var personName = "_hs-e";
export var pillContainer = "_hs-b";
export var selected = "_hs-1";
export var text = "_hs-c";
export var twoLines = "_hs-d";
export var unread = "_hs-f";
export var unreadIndicator = "_hs-g";